import CrudTab from 'react/containers/pages/CrudTab';

class GeotabSyncConfiguration extends CrudTab {
  static tabName = 'GeotabSyncConfiguration';

  componentDidMount() {
    this.router = new App.Routers.GeotabSync();
    this.router.showConfigForm();
  }

  goToCrudMethod = () => {
    this.router.showConfigForm();
  }
}

export default GeotabSyncConfiguration;
